/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ExternalImageMetadata,
    instanceOfExternalImageMetadata,
    ExternalImageMetadataFromJSON,
    ExternalImageMetadataFromJSONTyped,
    ExternalImageMetadataToJSON,
} from './ExternalImageMetadata';
import {
    ModelInfo,
    instanceOfModelInfo,
    ModelInfoFromJSON,
    ModelInfoFromJSONTyped,
    ModelInfoToJSON,
} from './ModelInfo';
import {
    OrthophotoMetadata,
    instanceOfOrthophotoMetadata,
    OrthophotoMetadataFromJSON,
    OrthophotoMetadataFromJSONTyped,
    OrthophotoMetadataToJSON,
} from './OrthophotoMetadata';
import {
    VolumeMetadata,
    instanceOfVolumeMetadata,
    VolumeMetadataFromJSON,
    VolumeMetadataFromJSONTyped,
    VolumeMetadataToJSON,
} from './VolumeMetadata';

/**
 * @type SurveyResourceAdditionalData
 * 
 * @export
 */
export type SurveyResourceAdditionalData = ExternalImageMetadata | ModelInfo | OrthophotoMetadata | VolumeMetadata;

export function SurveyResourceAdditionalDataFromJSON(json: any): SurveyResourceAdditionalData {
    return SurveyResourceAdditionalDataFromJSONTyped(json, false);
}

export function SurveyResourceAdditionalDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyResourceAdditionalData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...ExternalImageMetadataFromJSONTyped(json, true), ...ModelInfoFromJSONTyped(json, true), ...OrthophotoMetadataFromJSONTyped(json, true), ...VolumeMetadataFromJSONTyped(json, true) };
}

export function SurveyResourceAdditionalDataToJSON(value?: SurveyResourceAdditionalData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfExternalImageMetadata(value)) {
        return ExternalImageMetadataToJSON(value as ExternalImageMetadata);
    }
    if (instanceOfModelInfo(value)) {
        return ModelInfoToJSON(value as ModelInfo);
    }
    if (instanceOfOrthophotoMetadata(value)) {
        return OrthophotoMetadataToJSON(value as OrthophotoMetadata);
    }
    if (instanceOfVolumeMetadata(value)) {
        return VolumeMetadataToJSON(value as VolumeMetadata);
    }

    return {};
}

